import * as rd from '@devexperts/remote-data-ts'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { ErrorPage } from '@/components/ErrorPage'
import { LoaderTrigger } from '@/components/LoaderTrigger'
import { SPIT_DEBUG_SP_KEY } from '@/utils/constants'

const maintenanceSchema = z.object({
  description: z.record(z.string(), z.string()),
  enabled: z.boolean(),
  title: z.record(z.string(), z.string()),
})
type MaintenanceData = z.infer<typeof maintenanceSchema>

type Props = React.PropsWithChildren

export function Maintenance(props: Props) {
  const [maintenance, setMaintenance] = useState<
    rd.RemoteData<string, MaintenanceData>
  >(rd.initial)
  const { i18n } = useTranslation()

  useEffect(() => {
    const url = new URL(window.location.href)
    const isDebugMode = url.searchParams.get(SPIT_DEBUG_SP_KEY) === '1'
    if (isDebugMode) {
      setMaintenance(rd.failure('debug mode'))
      return
    }

    fetch(`${import.meta.env.VITE_ASSETS_URL}/booking/maintenance.json`)
      .then((res) => res.json())
      .then((res) => {
        const data = maintenanceSchema.safeParse(res)
        if (data.success) {
          setMaintenance(rd.success(data.data))
        } else {
          // eslint-disable-next-line no-console
          console.error('maintenance validation failed:', data.error)
          setMaintenance(rd.failure('validation failed'))
        }
      })
      .catch(() => setMaintenance(rd.failure('maintenance disabled')))
  }, [])

  if (rd.isInitial(maintenance) && rd.isPending(maintenance)) {
    return <LoaderTrigger />
  }

  if (rd.isSuccess(maintenance) && maintenance.value.enabled) {
    return (
      <ErrorPage
        description={maintenance.value.description[i18n.language]}
        title={maintenance.value.title[i18n.language]}
      />
    )
  }

  return <>{props.children}</>
}
